var exports = {
  "k": "xcc377c0b--46ee90--container",
};

module.exports = exports;
